module.exports = __webpack_public_path__ + "img/xiaozi_fazhan.a35e0aa2.svg";